<template>
  <div class="emb-faq-wrap">
    <emb-page-title
      :heading="bannerSection.Heading"
      :subHeading="bannerSection.Subheading"
      :image="bannerSection.Image1920x700
"
    ></emb-page-title>
    <div class="emb-faq-content section-gap pb-0">
      <div class="container">
        <div class="faq">
          <div class="sec-title mb-12">
            <div class="layout align-start">
              <h2 class="mb-6">{{faqSection.Title}}</h2>
            </div>
            <p v-html="faqSection.Subtitle"></p>
          </div>
          <div class="section-gap pt-4">
            <v-expansion-panels>
              <v-expansion-panel v-for="(faq,key) in questionSection" :key="key">
                <v-expansion-panel-header>
                  <h5 class="mb-0">{{faq.Question}}</h5>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{faq.Answer}}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div
        class="subscribe-block subscribe-bg section-gap text-center"
        :style="'background-image: url('+ bgImage +')'"
      >
        <div class="container pt-0">
          <v-layout row warp align-center justify-center>
            <v-flex sm12 xl6 lg6 md6>
              <h2 class="font-bold white--text mb-6">{{faqSection.Bottom_contet1}}</h2>
              <h6 class="white--text mb-6">{{faqSection.Bottom_contet2}}</h6>
              <v-btn class="accent" large to="/contact">{{faqSection.Send_Button_Label}}</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../services/utils/cms-helper";
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  data() {
    return {
      faq: "",
      faqSection: "",
      bannerSection: "",
      questionSection: "",
      bgImage: "",
    };
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  methods: {
    getPageData() {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "27 Faq/27 Faq/27 Faq.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          console.log(res);
          if (res.area_List) {
            var faqArea = self.cmsRequestFunctions.pluck(
              "Faq_Section",
              res.area_List
            );
            self.faqSection = self.cmsRequestFunctions.getAllMapData(
              faqArea[0].component
            );
            self.questionSection = self.faqSection.Question_List;
            self.bgImage = self.faqSection.Bottom_Image1920x700;
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );

            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>